/**
 * @generated SignedSource<<2bc7a8fb2bc5f5e128906e04ef01621a>>
 * @relayHash cea874859baf509a59340e2a5344922b
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cea874859baf509a59340e2a5344922b

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type closePullRequestMutation$variables = {
  pullRequestId: string;
};
export type closePullRequestMutation$data = {
  readonly closePullRequest: {
    readonly pullRequest: {
      readonly id: string;
      readonly state: PullRequestState;
      readonly viewerCanReopen: boolean;
    } | null;
  } | null;
};
export type closePullRequestMutation$rawResponse = {
  readonly closePullRequest: {
    readonly pullRequest: {
      readonly id: string;
      readonly state: PullRequestState;
      readonly viewerCanReopen: boolean;
    } | null;
  } | null;
};
export type closePullRequestMutation = {
  rawResponse: closePullRequestMutation$rawResponse;
  response: closePullRequestMutation$data;
  variables: closePullRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pullRequestId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "pullRequestId",
            "variableName": "pullRequestId"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "ClosePullRequestPayload",
    "kind": "LinkedField",
    "name": "closePullRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PullRequest",
        "kind": "LinkedField",
        "name": "pullRequest",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerCanReopen",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "closePullRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "closePullRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "cea874859baf509a59340e2a5344922b",
    "metadata": {},
    "name": "closePullRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5cde1648344203af1a0e790a6e116e4f";

export default node;
